export default "__VITE_ASSET__C$jf5BgS__"